import React, { useEffect, useState } from 'react';
import { Box, Typography, Container, Grid, CircularProgress } from '@mui/material';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase/config';

const LoadsPage = () => {
  const [loads, setLoads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLoads = async () => {
      try {
        const loadsRef = collection(db, 'loads');
        const loadsSnapshot = await getDocs(loadsRef);
        const loadsList = loadsSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setLoads(loadsList);
      } catch (error) {
        console.error('Error al cargar los envíos:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchLoads();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Envíos disponibles
      </Typography>
      
      {loads.length === 0 ? (
        <Typography variant="body1">
          No hay envíos disponibles en este momento.
        </Typography>
      ) : (
        <Grid container spacing={3}>
          {loads.map(load => (
            <Grid item xs={12} sm={6} md={4} key={load.id}>
              <Box 
                sx={{ 
                  p: 2, 
                  border: '1px solid #ddd', 
                  borderRadius: 2,
                  '&:hover': {
                    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                  }
                }}
              >
                <Typography variant="h6">
                  {load.origin} → {load.destination}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Fecha: {load.date ? new Date(load.date.seconds * 1000).toLocaleDateString() : 'No especificada'}
                </Typography>
                <Typography variant="body1" fontWeight="bold" sx={{ mt: 1 }}>
                  {load.price ? `${load.price} €` : 'Precio a convenir'}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      )}
    </Container>
  );
};

export default LoadsPage; 